import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "landing-wr" }
const _hoisted_2 = {
  key: 1,
  class: "header-desktop"
}
const _hoisted_3 = { class: "header-controls" }
const _hoisted_4 = { class: "wrapper-desktop-switcher" }
const _hoisted_5 = { class: "landing-body" }
const _hoisted_6 = { class: "dashboard-wr" }
const _hoisted_7 = { class: "dashboard" }
const _hoisted_8 = {
  class: "dashboard--header",
  "data-aos": "zoom-out",
  "data-aos-once": "true"
}
const _hoisted_9 = {
  class: "title",
  "data-aos": "fade-down",
  "fade-down-duration": "500",
  "data-aos-once": "true"
}
const _hoisted_10 = {
  key: 0,
  class: "title",
  "data-aos": "fade-down",
  "fade-down-duration": "500",
  "data-aos-once": "true"
}
const _hoisted_11 = { class: "estate-map landing-plans-map" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "estate-map-body" }
const _hoisted_14 = { class: "pricing-plans" }
const _hoisted_15 = { class: "plans-container" }
const _hoisted_16 = { class: "content-description" }
const _hoisted_17 = { class: "description-plans" }
const _hoisted_18 = { class: "project-sales-and-marketing" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoWithIcon = _resolveComponent("InfoWithIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.isDesktop)
      ? (_openBlock(), _createBlock($setup["LandingMobileHeader"], {
          key: 0,
          onSignIn: $setup.onLogin
        }))
      : (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/')))
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode($setup["SwitchComponent"], {
                class: "landing",
                list: $setup.visibleHeaderTabs,
                modelValue: $setup.activeHeaderTab,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (($setup.activeHeaderTab) = $event)),
                  $setup.onChangeHeaderTab
                ]
              }, null, 8, ["list", "modelValue"])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "divider" }, null, -1)),
            _createElementVNode("div", { class: "buttons" }, [
              _createElementVNode("button", {
                class: "link-primary",
                onClick: $setup.onLogin
              }, "sign in")
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "landing-badge",
              "data-aos": "fade-down",
              "fade-down-duration": "500"
            }, "PLANS", -1)),
            _createElementVNode("h1", _hoisted_9, [
              _cache[9] || (_cache[9] = _createTextVNode(" Showcase ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "bold" }, "real-time availability ", -1)),
              _createTextVNode(_toDisplayString($setup.isDesktop ? "with an" : "with an interactive masterplan on your website."), 1)
            ]),
            ($setup.isDesktop)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_10, "interactive masterplan on your website."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["estate-map-wrapper-map", { 'estate-map-wr-embedded': $setup.isEmbedded && $setup.isDesktop }])
                }, [
                  (!$setup.showStageMap)
                    ? (_openBlock(), _createBlock($setup["EstateMap"], {
                        key: 0,
                        role: $setup.UserRoles.CUSTOMER,
                        isEmbedded: false,
                        mapPage: $setup.MapPages.ESTATE_MAP,
                        zoom: $setup.zoom,
                        estateId: $setup.mapEstateId,
                        hideMapSidePanelOptions: true,
                        plansView: true,
                        onUpdateZoom: $setup.updateZoom,
                        onOnMessage: $setup.onMessage
                      }, null, 8, ["role", "mapPage", "zoom", "estateId"]))
                    : _createCommentVNode("", true),
                  ($setup.showStageMap)
                    ? (_openBlock(), _createBlock($setup["StageMap"], {
                        key: 1,
                        role: $setup.UserRoles.CUSTOMER,
                        isEmbedded: false,
                        mapPage: $setup.MapPages.STAGE_MAP,
                        zoom: $setup.zoom,
                        estateId: $setup.mapEstateId,
                        plansView: true,
                        hideMapSidePanelOptions: true,
                        onReserve: _cache[2] || (_cache[2] = ($event: any) => ($setup.onReserve($event))),
                        onUpdateZoom: $setup.updateZoom,
                        onOnRegister: _ctx.onRegister,
                        onOnMessage: $setup.onMessage,
                        onOnLotBuilderHover: _cache[3] || (_cache[3] = (value) => ($setup.lotBuilderIconHover = value)),
                        onOnMouseX: _cache[4] || (_cache[4] = (value) => ($setup.mouseX = value)),
                        onOnMouseY: _cache[5] || (_cache[5] = (value) => ($setup.mouseY = value))
                      }, null, 8, ["role", "mapPage", "zoom", "estateId", "onOnRegister"]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createVNode($setup["ReserveLotModal"], {
                isOpen: $setup.showReserveModal,
                lot: $setup.lotForReserve,
                embedded: $setup.isEmbedded,
                "transition-name": $setup.transitionName,
                estate: $setup.estate,
                estateId: $setup.mapEstateId,
                buttonsDisabled: true,
                onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.closeReserveModal($event))),
                onToContact: _ctx.showContactWithQuestion,
                onReserve: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onReserveLot($event))),
                onHold: _ctx.onHoldRequest,
                onToRequestQuote: _ctx.onRequestQuote,
                onUpdateHeaderOverAll: _ctx.updateHeaderOverAll
              }, null, 8, ["isOpen", "lot", "embedded", "transition-name", "estate", "estateId", "onToContact", "onHold", "onToRequestQuote", "onUpdateHeaderOverAll"]),
              ($setup.lotBuilderIconHover)
                ? (_openBlock(), _createBlock(_component_InfoWithIcon, {
                    key: 0,
                    class: "builder-icon-info-component",
                    style: _normalizeStyle({ top: `${$setup.mouseY}px`, left: `${$setup.mouseX}px` }),
                    text: 'This lot is eligible for you to build your own home and land package.'
                  }, null, 8, ["style"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_14, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title-plans-container" }, [
          _createElementVNode("h1", { class: "title" }, [
            _createTextVNode("Not setup costs. "),
            _createElementVNode("span", { class: "text-normal" }, "Get started free today.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.landingSubscriptionPlansData, (plan) => {
            return (_openBlock(), _createBlock($setup["CardSubscription"], {
              key: plan.title,
              type: plan.type,
              icon: plan.icon,
              title: plan.title,
              price: plan.price,
              subtitle: plan.subtitle,
              buttonText: plan.buttonText,
              subtitleFeatures: plan.subtitleFeatures,
              features: plan.features
            }, null, 8, ["type", "icon", "title", "price", "subtitle", "buttonText", "subtitleFeatures", "features"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString($setup.landingDescriptionPlansData), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_18, [
        _createVNode($setup["ProjectSalesAndMarketing"], { features: $setup.landingProjectSalesAndMarketingData }, null, 8, ["features"])
      ])
    ]),
    _createVNode($setup["LandingFooter"], { isPlansView: true })
  ]))
}